import { SET_SELECTED_PERIOD_INFO, SET_SELECTED_PERIOD_INFO_ERROR, SET_SELECTED_PERIOD_INFO_LOADING, SET_SELECTED_PERIOD_INFO_RESET } from '../types'

const initialState = {
  error: false,
  loaded: false,
  info: {},
}

export const selectedPeriodInfo = (state = initialState, action ) => {
  switch (action.type) {
    case SET_SELECTED_PERIOD_INFO_LOADING:
      return{
        ...state,
        loaded: false,
        error: false
      }
    case SET_SELECTED_PERIOD_INFO:
      return {
        ...state,
        info: {
          ...action.payload
        },
        loaded: true,
        error: false
      }

    case SET_SELECTED_PERIOD_INFO_ERROR:
      return{
        ...state,
        loaded: false,
        error: true,
        message: action.payload
      }

    case SET_SELECTED_PERIOD_INFO_RESET: 
      return {
        error: false,
        loaded: false,
        info: {},
      }
    
      default:
        return state
    }
}